import {
  TYPE_CITATIONS,
  TYPE_GRAMMAR,
  TYPE_PLAGIARISM,
  TYPE_EXPERT_CHECK,
  HOMEPAGE_FEATURE_TOUR,
} from '@chegg-wt/core/constants/plusTab'
import {
  TYPE_CREATE_CITATIONS,
  TYPE_CHECK_PAPER,
  HOMEPAGE_CARD,
} from '@chegg-wt/core/constants/card'
import { AuthModalOrigin } from '@chegg-wt/core/components/Modals/AuthModal/types'
import {
  CLOSE,
  LOGIN,
  CREATE_ACCOUNT,
} from '@chegg-wt/core/components/Modals/UnlockAccountGateModal/constants'
import { SendEventParams } from '@chegg/rio-sdk-web/dist/types/events/sendEvent'
import { CitationMetadata } from '@chegg-wt/core/types/autocite'

export const selectNavShortcut = 'select nav shortcut'
export const clickUpgrade = 'click upgrade'
export const clickReview = 'click review'
export const feedbackCard = 'feedback card'
export const flagFeedbackCard = 'flag feedback card'
export type EventName =
  | typeof selectNavShortcut
  | typeof clickUpgrade
  | typeof clickReview
  | typeof feedbackCard
  | typeof flagFeedbackCard

export const linkType = 'link'
export const buttonType = 'button'
export const componentType = 'component'
export const dropdownType = 'drop down'
export const icon = 'icon'
export const textType = 'text'

export type ElementType =
  | typeof linkType
  | typeof buttonType
  | typeof componentType
  | typeof dropdownType
  | typeof icon
  | typeof textType

export const select = 'select'
export const expand = 'expand'
export const shorten = 'shorten'
export const collapse = 'collapse'
export const click = 'click'
export const accept = 'accept'
export const regenerate = 'regenerate'
export const reject = 'reject'
export const typed = 'typed'

export type InteractionType =
  | typeof select
  | typeof expand
  | typeof collapse
  | typeof click
  | typeof accept
  | typeof reject
  | typeof typed

export const dashboard = 'holistic dash'
export const onboardingModalWTDashboard = 'onboarding modal WT Dashboard'
export const citationsDash = 'citations dash'
export const papersDash = 'papers dash'
export const citationForm = 'citation form'
export const bibliography = 'citation bibliography'
export const getStarted = 'get started'
export const createAccountExitPopup = 'create account - exit popup'
export const checkPaperExitPopup = 'check paper - exit popup'
export const checkPaper = 'check paper'
export const createAccountStyleGate = 'create account - style gate'
export const createAccountCitationUnlockModal = 'create account - citation unlock modal'
export const citationUnlockModal = 'citation unlock modal'
export const formPageAddAnnotationCTA = 'add annotation'
export const createManualCitationCTA = 'create manual citation'
export const worldCatLogo = 'worldcat logo'
export const findAtMyLibrary = 'find at my library'
export const updateCitation = 'update citation'
export const editCitation = 'edit citation'
export const reviewCitation = 'review citation'
export const copyAllCitations = 'copy all'
export const addContributors = 'add contributors'
export const ignoreValidation = 'ignore validation'
export const visitSourceLink = 'visit source link'
export const deleteCitation = 'delete citation'
export const createCitation = 'create citation'
export const exportCitation = 'export'
export const exportSelectedCitations = 'export selected'
export const deleteSelectedCitations = 'delete selected'
export const copySelectedCitations = 'copy selected'
export const viewSponsoredMessage = 'view a sponsored message'
export const signUp = 'sign up'
export const signIn = 'sign in'
export const copyCitation = 'copy citation'
export const exportAllCitations = 'export all'
export const checkYourPaper = 'check your paper'
export const createCitations = 'create citations'
export const lookingForWebsite = 'looking for website'
export const createManualCitation = 'create a manual citation'
export const searchWithJstor = 'search with jstor'
export const searchWithCrossref = 'search with crossref'
export const doNotUpgrade = 'do not upgrade'
export const upgrade = 'upgrade'
export const citationStyle = 'citation style'
export const moreCitationStyles = 'more citation styles'
export const navShortcut = 'nav shortcut'
export const claimOffer = 'claim offer'
export const tryForFree = 'try for free'
export const modalContinue = 'continue'
export const upgradeBanner = 'citation and writing free trial'
export const modalCreateNewList = 'create new list'
export const modalStartFreeTrial = 'start free trial'
export const createAccount = 'create account'
export const createAFreeAccount = 'create a free account'
export const tryItForFreeToday = 'try it for free today'
export const review = 'review'
export const paraphrase = 'paraphrase'
export const paraphraseSuggestion = 'paraphrase suggestion'
export const expandSuggestion = 'expand suggestion'
export const shortenSuggestion = 'shorten suggestion'
export const regenerateExpandSuggestion = 'regenerate expand suggestion'
export const regenerateShortenSuggestion = 'regenerate shorten suggestion'
export const regenerateSuggestion = 'regenerate paraphrase suggestion'
export const flagParaphraseSuggestion = 'flag paraphrase suggestion'
export const flagExpandSuggestion = 'flag expand suggestion'
export const flagShortenSuggestion = 'flag shorten suggestion'
export const synonym = 'synonym'
export const synonymSuggestion = 'synonym suggestion'
export const undo = 'undo'
export const redo = 'redo'
export const papersList = 'papers list'
export const startNewPaper = 'start new paper'
export const paper = 'paper'

type Name =
  | typeof dashboard
  | typeof onboardingModalWTDashboard
  | typeof addCitationNote
  | typeof citationsDash
  | typeof papersDash
  | typeof citationForm
  | typeof bibliography
  | typeof getStarted
  | typeof createAccountExitPopup
  | typeof checkPaperExitPopup
  | typeof checkPaper
  | typeof createAccountStyleGate
  | typeof createAccountCitationUnlockModal
  | typeof citationUnlockModal
  | typeof formPageAddAnnotationCTA
  | typeof createManualCitationCTA
  | typeof worldCatLogo
  | typeof findAtMyLibrary
  | typeof updateCitation
  | typeof deleteCitation
  | typeof editCitation
  | typeof reviewCitation
  | typeof copyAllCitations
  | typeof addContributors
  | typeof ignoreValidation
  | typeof visitSourceLink
  | typeof createCitation
  | typeof exportCitation
  | typeof exportSelectedCitations
  | typeof deleteSelectedCitations
  | typeof copySelectedCitations
  | typeof viewSponsoredMessage
  | typeof signUp
  | typeof signIn
  | typeof copyCitation
  | typeof exportAllCitations
  | typeof checkYourPaper
  | typeof createCitations
  | typeof lookingForWebsite
  | typeof createManualCitation
  | typeof searchWithJstor
  | typeof searchWithCrossref
  | typeof doNotUpgrade
  | typeof upgrade
  | typeof navShortcut
  | typeof tryForFree
  | typeof review
  | typeof paraphrase
  | typeof paraphraseSuggestion
  | typeof regenerateSuggestion
  | typeof flagParaphraseSuggestion
  | typeof synonym
  | typeof synonymSuggestion
  | typeof undo
  | typeof redo
  | typeof papersList
  | typeof startNewPaper
  | typeof paper

export const plusCTARegion = 'signup for plus cta'
export const citationsCTARegion = 'citations cta'
export const holisticCitationWidgetCTARegion = 'holistic dashboard citation widget'
export const holisticPaperUploadWidgetCTARegion = 'holistic dashboard paper upload widget'
export const citationDashCitationWidgetCTARegion = 'citation dashboard citation widget'
export const paperListRegion = 'papers list'
export const citationListRegion = 'citations list'
export const citationWidgetRegion = 'citation source widget'
export const paperUploadWidgetRegion = 'paper upload widget'
export const topUpgradeBannerRegion = 'top banner'
export const addCitationNote = 'notes'
export const bibliographyModuleRegion = 'bibliography module'
export const copyInTextCitationMenuRegion = 'citation menu'
export const exitPopup = 'exit popup'
export const styleGateRegion = 'style gate'
export const unlockModalRegion = 'unlock modal'
export const formPageRegion = 'citation form'
export const searchPageRegion = 'citation search widget'
export const citationMenuRegion = 'citation menu'
export const exportAllModuleRegion = 'export all module'
export const checkboxesMenuRegion = 'checkboxes menu'
export const unlockCitationRegion = 'unlock citation'
export const myCitationListRegion = 'my citation list'
export const paperCheckerWidgetRegion = 'paper checker widget'
export const expertCheckTourRegion = 'expert check feature tour'
export const homepageMainWritingCTARegion = 'homepage main writing cta'
export const plagiarismFeatureTourRegion = 'plagiarism feature tour'
export const grammarFeatureTourRegion = 'grammar feature tour'
export const citationsFeatureTourRegion = 'citations feature tour'
export const empCitationSearchResultRegion = 'empty citation search result'
export const upgradeContainerRegion = 'upgrade container'
export const exportCitationRegion = 'export citation'
export const createCitationRegion = 'create citation'
export const upgradeCreateCitationRegion = 'upgrade to create citation'
export const viewCitationListRegion = 'view citation list'
export const upgradeViewCitationListRegion = 'upgrade to view citation list'
export const sideNavRegion = 'side nav'
export const topNavRegion = 'top nav'
export const tryCitationStylesRegion = 'try citation styles'
export const changeCitationStyleModalRegion = 'change citation style'
export const newCitationListModalRegion = 'add citation modal'
export const citationsExpiring = 'citations expiring'
export const saveAllCitations = 'save all citations'
export const clickToContinueCitingRegion = 'click to continue citing'
export const grammar = 'grammar'
export const clarity = 'clarity'
export const writingAssistantBanner = 'writing assistant banner'
export const writingAssistantTitle = 'writing assistant'
export const plagiarismTitle = 'plagiarism'
export const citationsTitle = 'citations'
export const waBottomSection = 'writing assistant bottom section'
export const citationsBottomSection = 'citations bottom section'
export const plagiarismBottomSection = 'plagiarism bottom section'
export const leftNav = 'left nav'

export type Region =
  | typeof plusCTARegion
  | typeof paperListRegion
  | typeof holisticCitationWidgetCTARegion
  | typeof holisticPaperUploadWidgetCTARegion
  | typeof citationDashCitationWidgetCTARegion
  | typeof citationListRegion
  | typeof citationMenuRegion
  | typeof citationWidgetRegion
  | typeof paperUploadWidgetRegion
  | typeof citationsCTARegion
  | typeof bibliographyModuleRegion
  | typeof copyInTextCitationMenuRegion
  | typeof exitPopup
  | typeof styleGateRegion
  | typeof unlockModalRegion
  | typeof formPageRegion
  | typeof searchPageRegion
  | typeof exportAllModuleRegion
  | typeof checkboxesMenuRegion
  | typeof unlockCitationRegion
  | typeof myCitationListRegion
  | typeof paperCheckerWidgetRegion
  | typeof expertCheckTourRegion
  | typeof homepageMainWritingCTARegion
  | typeof plagiarismFeatureTourRegion
  | typeof grammarFeatureTourRegion
  | typeof citationsFeatureTourRegion
  | typeof empCitationSearchResultRegion
  | typeof upgradeContainerRegion
  | typeof exportCitationRegion
  | typeof createCitationRegion
  | typeof upgradeCreateCitationRegion
  | typeof viewCitationListRegion
  | typeof upgradeViewCitationListRegion
  | typeof sideNavRegion
  | typeof topNavRegion
  | typeof tryCitationStylesRegion
  | typeof changeCitationStyleModalRegion
  | typeof topUpgradeBannerRegion
  | typeof newCitationListModalRegion
  | typeof citationsExpiring
  | typeof saveAllCitations
  | typeof clickToContinueCitingRegion
  | typeof grammar
  | typeof clarity
  | typeof writingAssistantBanner
  | typeof writingAssistantTitle
  | typeof citationsTitle
  | typeof plagiarismTitle
  | typeof waBottomSection
  | typeof citationsBottomSection
  | typeof plagiarismBottomSection
  | typeof leftNav

export interface ClickstreamInteractionPayload {
  eventname?: EventName | string
  name: Name | string
  type: ElementType
  interactionType?: InteractionType
  region?: Region
  text?: string
  value?: string
  id?: string
  force?: boolean
  options?: SendEventParams['options']
  style?: string
  citationMetadata?: CitationMetadata
}

export type Interactions = {
  dashboardClickSource: (value: string) => ClickstreamInteractionPayload
  citationsDashClickSource: (value: string) => ClickstreamInteractionPayload
  dashboardClickProjectSeeAll: () => ClickstreamInteractionPayload
  dashboardClickPaperSeeAll: () => ClickstreamInteractionPayload
  dashboardClickPaper: () => ClickstreamInteractionPayload
  dashboardClickProjectCitation: () => ClickstreamInteractionPayload
  dashboardClickGPCTA: () => ClickstreamInteractionPayload
  dashboardClickECCTA: () => ClickstreamInteractionPayload
  citationsFlowClickCreate: (
    source: string,
    citationMetadata: CitationMetadata
  ) => ClickstreamInteractionPayload
  dashboardClickCitationCTA: () => ClickstreamInteractionPayload
  dashboardCreateAccountCitationWidgetCTA: () => ClickstreamInteractionPayload
  dashboardSignInCitationWidgetCTA: () => ClickstreamInteractionPayload
  dashboardCreateAccountPaperUploadWidgetCTA: () => ClickstreamInteractionPayload
  dashboardSignInPaperUploadWidgetCTA: () => ClickstreamInteractionPayload
  dashboardCheckMyPaperUploadWidgetCTA: () => ClickstreamInteractionPayload
  dashboardMyComputerUploadWidgetCTA: () => ClickstreamInteractionPayload
  dashboardGoogleDriveUploadWidgetCTA: () => ClickstreamInteractionPayload
  dashboardTourStep: () => ClickstreamInteractionPayload
  citationsDashCreateAccountCitationListCTA: () => ClickstreamInteractionPayload
  citationsDashSignInCitationListCTA: () => ClickstreamInteractionPayload
  citationsDashCreateAccountCitationWidgetCTA: () => ClickstreamInteractionPayload
  citationsDashSignInCitationWidgetCTA: () => ClickstreamInteractionPayload
  citationsDashClickCTA: () => ClickstreamInteractionPayload
  copyInTextCitationHoverCTA: () => ClickstreamInteractionPayload
  copyInTextCitationMenuCTA: () => ClickstreamInteractionPayload
  styleChangeClick: () => ClickstreamInteractionPayload
  styleChangeSelect: (value: string, style: string) => ClickstreamInteractionPayload
  homePageCitationsFeatureTourCTA: () => ClickstreamInteractionPayload
  homePageGrammarFeatureTourCTA: () => ClickstreamInteractionPayload
  homePagePlagiarismFeatureTourCTA: () => ClickstreamInteractionPayload
  homePageExpertCheckFeatureTourCTA: () => ClickstreamInteractionPayload
  createAccountExitPopup: () => ClickstreamInteractionPayload
  checkPaperExitPopup: () => ClickstreamInteractionPayload
  signInExitPopup: () => ClickstreamInteractionPayload
  closeModalCreateAccountExitPopup: () => ClickstreamInteractionPayload
  createAccountStyleGateModalCTA: () => ClickstreamInteractionPayload
  createAccountStyleGateModalClickSignIn: () => ClickstreamInteractionPayload
  closeCreateAccountStyleGateModal: () => ClickstreamInteractionPayload
  accountGateModalClickUnlock: (
    options?: SendEventParams['options']
  ) => ClickstreamInteractionPayload
  createAccountUnlockModal: (
    options?: SendEventParams['options']
  ) => ClickstreamInteractionPayload
  closeModalCheckPaperExitPopup: () => ClickstreamInteractionPayload
  homePageMainCitationsCardCTA: () => ClickstreamInteractionPayload
  homePageMainWritingCardCTA: () => ClickstreamInteractionPayload
  citationHomepageModalSignIn: (
    options?: SendEventParams['options']
  ) => ClickstreamInteractionPayload
  formPageAddAnnotationCTA: () => ClickstreamInteractionPayload
  createManualCitationCTA: (region: Region) => ClickstreamInteractionPayload
  worldCatLogoClick: () => ClickstreamInteractionPayload
  findAtMyLibraryClick: () => ClickstreamInteractionPayload
  citationsFlowClickUpdate: (
    source: string,
    citationMetadata?: CitationMetadata
  ) => ClickstreamInteractionPayload
  deleteCitationClick: () => ClickstreamInteractionPayload
  editCitationClick: () => ClickstreamInteractionPayload
  reviewCitationClick: () => ClickstreamInteractionPayload
  copyAllCitationsClick: () => ClickstreamInteractionPayload
  addNoteClick: () => ClickstreamInteractionPayload
  formPageAddContributorsCTA: () => ClickstreamInteractionPayload
  ignoreValidationClick: () => ClickstreamInteractionPayload
  visitSourceLinkClick: () => ClickstreamInteractionPayload
  createNewCitationClick: () => ClickstreamInteractionPayload
  exportModuleExportCitationsClick: (value: string) => ClickstreamInteractionPayload
  exportSelectedCitationsClick: () => ClickstreamInteractionPayload
  deleteSelectedCitationsClick: () => ClickstreamInteractionPayload
  copySelectedCitationsClick: () => ClickstreamInteractionPayload
  unlockModalSponsoredClick: (
    options?: SendEventParams['options']
  ) => ClickstreamInteractionPayload
  unlockModalSubscribeClick: (
    value: string,
    options?: SendEventParams['options']
  ) => ClickstreamInteractionPayload
  unlockModalSignInClick: (
    options?: SendEventParams['options']
  ) => ClickstreamInteractionPayload
  copyBibliographyCitationClick: () => ClickstreamInteractionPayload
  exportAllCitationsClick: () => ClickstreamInteractionPayload
  checkPaperAfterCopy: () => ClickstreamInteractionPayload
  checkPaperAfterLogout: () => ClickstreamInteractionPayload
  signUpClick: (value: string) => ClickstreamInteractionPayload
  copyBibliographyCitationFromMenu: () => ClickstreamInteractionPayload
  lookForWebsiteAfterSearchResult: () => ClickstreamInteractionPayload
  searchWithJstorAfterSearchResult: () => ClickstreamInteractionPayload
  searchWithCrossrefAfterSearchResult: () => ClickstreamInteractionPayload
  plagiarismUpsellCardCTA: (name: string) => ClickstreamInteractionPayload
  gatedExportContinueCTA: (text: string) => ClickstreamInteractionPayload
  gatedExportUpgradeCTA: (text: string) => ClickstreamInteractionPayload
  citationLimitApproachingContinueCTA: (text: string) => ClickstreamInteractionPayload
  citationLimitApproachingUpgradeCTA: (text: string) => ClickstreamInteractionPayload
  citationLimitReachedUpgradeCTA: (text: string) => ClickstreamInteractionPayload
  foldersPageExpirationUpgradeCTA: (text: string) => ClickstreamInteractionPayload
  bibPageExpirationContinueCTA: (text: string) => ClickstreamInteractionPayload
  bibPageExpirationUpgradeCTA: (text: string) => ClickstreamInteractionPayload
  citationStyleClick: (text: string) => ClickstreamInteractionPayload
  moreCitationsStyleClick: (
    interactionType: InteractionType
  ) => ClickstreamInteractionPayload
  topSideNavItemClick: (value: string, text: string) => ClickstreamInteractionPayload
  topNavItemClick: (value: string, text: string) => ClickstreamInteractionPayload
  siteLogoClick: (name: string) => ClickstreamInteractionPayload
  upgradeTopNavClick: () => ClickstreamInteractionPayload
  upgradeSourcePageCTA: (eventname: string, name: string) => ClickstreamInteractionPayload
  upgradeSearchPageCTA: (eventname: string, name: string) => ClickstreamInteractionPayload
  priceModalClaimOfferClick: (text: string) => ClickstreamInteractionPayload

  freeCTAUpgradeClick: () => ClickstreamInteractionPayload
  changeCitationStyleModalContinueClick: () => ClickstreamInteractionPayload
  upgradeBannerCTA: () => ClickstreamInteractionPayload
  newCitationListModalCreateClick: () => ClickstreamInteractionPayload
  newCitationListModalStartClick: () => ClickstreamInteractionPayload
  citationValidityCreateAccountClick: (
    citationMetadata: CitationMetadata
  ) => ClickstreamInteractionPayload
  saveAllCitationsCreateAccountClick: () => ClickstreamInteractionPayload
  createFreeAccountAdUnlockModalClick: () => ClickstreamInteractionPayload
  tryItForFreeTodayAdUnlockModalClick: () => ClickstreamInteractionPayload
  proofReaderReviewClick: (value: string) => ClickstreamInteractionPayload
  proofReaderRewriteClick: (text: string) => ClickstreamInteractionPayload
  proofReaderExpandClick: (text: string) => ClickstreamInteractionPayload
  proofReaderShortenClick: (text: string) => ClickstreamInteractionPayload
  proofReaderSynonymClick: (text: string) => ClickstreamInteractionPayload
  writingAssistantBannerClick: () => ClickstreamInteractionPayload
  proofReaderSynonymSuggestionClick: (
    text: string,
    value: string
  ) => ClickstreamInteractionPayload
  proofReaderRewriteSuggestionClick: (
    text: string,
    value: string,
    citationMetadata: CitationMetadata
  ) => ClickstreamInteractionPayload
  proofReaderExpandSuggestionClick: (
    text: string,
    value: string,
    citationMetadata: CitationMetadata
  ) => ClickstreamInteractionPayload
  proofReaderShortenSuggestionClick: (
    text: string,
    value: string,
    citationMetadata: CitationMetadata
  ) => ClickstreamInteractionPayload
  proofReaderFeedbackCardClick: (
    text: string,
    value: string,
    id: string,
    citationMetadata: CitationMetadata
  ) => ClickstreamInteractionPayload
  undoRedoClick: (
    name: Name | string,
    type: ElementType,
    interactionType: InteractionType,
    value?: string,
    text?: string,
    id?: string
  ) => ClickstreamInteractionPayload
  carousalImageGetStartedClick: (
    name: string,
    region: Region
  ) => ClickstreamInteractionPayload
  bannerTextGetStartedClick: (
    name: string,
    region: Region
  ) => ClickstreamInteractionPayload
  expandClarityReasonClick: (
    text: string,
    value: string,
    id: string
  ) => ClickstreamInteractionPayload
  contractClarityReasonClick: (
    text: string,
    value: string,
    id: string
  ) => ClickstreamInteractionPayload
  proofReaderRetryErrorClick: (value: string) => ClickstreamInteractionPayload
  expandPaperListClick: () => ClickstreamInteractionPayload
  collapsePaperListClick: () => ClickstreamInteractionPayload
  startNewPaperClick: () => ClickstreamInteractionPayload
  citationsLeftNavClick: () => ClickstreamInteractionPayload
  plagiarismLeftNavClick: () => ClickstreamInteractionPayload
  randomListPaperClick: () => ClickstreamInteractionPayload
}

export const interactions: Interactions = {
  dashboardClickSource: (value: string) => ({
    name: dashboard,
    type: linkType,
    region: citationWidgetRegion,
    text: 'click on a source',
    value,
  }),
  citationsDashClickSource: (value: string) => ({
    name: citationsDash,
    type: linkType,
    region: citationWidgetRegion,
    text: 'click on a source',
    value,
  }),
  dashboardClickProjectSeeAll: () => ({
    name: dashboard,
    type: linkType,
    region: citationListRegion,
    text: 'click see all',
  }),
  dashboardClickPaperSeeAll: () => ({
    name: dashboard,
    type: linkType,
    region: paperListRegion,
    text: 'click see all',
  }),
  dashboardClickPaper: () => ({
    name: dashboard,
    type: linkType,
    region: paperListRegion,
    text: 'click on a paper',
  }),
  dashboardClickProjectCitation: () => ({
    name: dashboard,
    type: linkType,
    region: citationListRegion,
    text: 'click previous citation list',
  }),
  dashboardClickGPCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: plusCTARegion,
    text: 'plagiarism check cta',
  }),
  dashboardClickECCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: plusCTARegion,
    text: 'expert check cta',
  }),
  citationsFlowClickCreate: (source, citationMetadata) => ({
    name: citationForm,
    type: buttonType,
    value: source,
    text: 'create citation',
    citationMetadata,
  }),
  dashboardClickCitationCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: citationsCTARegion,
    text: 'start free trial',
  }),
  dashboardCreateAccountCitationWidgetCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: holisticCitationWidgetCTARegion,
    text: 'create account - citation widget',
  }),
  dashboardSignInCitationWidgetCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: holisticCitationWidgetCTARegion,
    text: 'sign in - citation widget',
  }),
  dashboardCreateAccountPaperUploadWidgetCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: holisticPaperUploadWidgetCTARegion,
    text: 'create account - paper upload widget',
  }),
  dashboardSignInPaperUploadWidgetCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: holisticPaperUploadWidgetCTARegion,
    text: 'sign in - paper upload widget',
  }),
  dashboardCheckMyPaperUploadWidgetCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: paperUploadWidgetRegion,
    text: 'check my paper',
  }),
  dashboardMyComputerUploadWidgetCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: paperUploadWidgetRegion,
    text: 'click my computer',
  }),
  dashboardGoogleDriveUploadWidgetCTA: () => ({
    name: dashboard,
    type: buttonType,
    region: paperUploadWidgetRegion,
    text: 'click google drive',
  }),
  dashboardTourStep: () => ({
    name: onboardingModalWTDashboard,
    type: componentType,
  }),
  citationsDashCreateAccountCitationListCTA: () => ({
    name: citationsDash,
    type: buttonType,
    region: citationDashCitationWidgetCTARegion,
    text: 'create account - citation list',
  }),
  citationsDashSignInCitationListCTA: () => ({
    name: citationsDash,
    type: buttonType,
    region: citationDashCitationWidgetCTARegion,
    text: 'sign in - citation list',
  }),
  citationsDashCreateAccountCitationWidgetCTA: () => ({
    name: citationsDash,
    type: buttonType,
    region: citationDashCitationWidgetCTARegion,
    text: 'create account - citation widget',
  }),
  citationsDashSignInCitationWidgetCTA: () => ({
    name: citationsDash,
    type: buttonType,
    region: citationDashCitationWidgetCTARegion,
    text: 'sign in - citation widget',
  }),
  citationsDashClickCTA: () => ({
    name: citationsDash,
    type: buttonType,
    region: citationsCTARegion,
    text: 'start free trial',
  }),
  copyInTextCitationHoverCTA: () => ({
    name: bibliography,
    type: buttonType,
    region: bibliographyModuleRegion,
    text: 'copy in-text citation',
  }),
  copyInTextCitationMenuCTA: () => ({
    name: bibliography,
    type: buttonType,
    region: copyInTextCitationMenuRegion,
    text: 'copy in-text citation',
  }),
  styleChangeClick: () => ({
    name: bibliography,
    type: buttonType,
    region: bibliographyModuleRegion,
    text: 'change style',
  }),
  styleChangeSelect: (value, style) => ({
    name: bibliography,
    type: buttonType,
    region: bibliographyModuleRegion,
    text: 'click on a style',
    value,
    style,
  }),
  homePageCitationsFeatureTourCTA: () => ({
    name: getStarted,
    type: buttonType,
    region: citationsFeatureTourRegion,
    force: true,
  }),
  homePageGrammarFeatureTourCTA: () => ({
    name: getStarted,
    type: buttonType,
    region: grammarFeatureTourRegion,
    force: true,
  }),
  homePagePlagiarismFeatureTourCTA: () => ({
    name: getStarted,
    type: buttonType,
    region: plagiarismFeatureTourRegion,
    force: true,
  }),
  homePageExpertCheckFeatureTourCTA: () => ({
    name: getStarted,
    type: buttonType,
    region: expertCheckTourRegion,
  }),
  createAccountExitPopup: () => ({
    name: createAccountExitPopup,
    type: buttonType,
    region: exitPopup,
    text: 'create account',
  }),
  checkPaperExitPopup: () => ({
    name: checkPaperExitPopup,
    type: buttonType,
    region: exitPopup,
    text: 'enter paper product',
  }),
  closeModalCheckPaperExitPopup: () => ({
    name: checkPaperExitPopup,
    type: buttonType,
    region: exitPopup,
    text: 'exit prompt to enter paper product',
  }),
  signInExitPopup: () => ({
    name: createAccountExitPopup,
    type: buttonType,
    region: exitPopup,
    text: 'sign in',
  }),
  closeModalCreateAccountExitPopup: () => ({
    name: createAccountExitPopup,
    type: buttonType,
    region: exitPopup,
    text: 'exit without account creation',
  }),
  createAccountStyleGateModalCTA: () => ({
    name: createAccountStyleGate,
    type: buttonType,
    region: styleGateRegion,
    text: 'create account',
  }),
  createAccountStyleGateModalClickSignIn: () => ({
    name: createAccountStyleGate,
    type: buttonType,
    region: styleGateRegion,
    text: 'sign in',
  }),
  closeCreateAccountStyleGateModal: () => ({
    name: createAccountStyleGate,
    type: buttonType,
    region: styleGateRegion,
    text: 'exit without account creation',
  }),
  accountGateModalClickUnlock: (options?: SendEventParams['options']) => ({
    name: createAccountCitationUnlockModal,
    type: buttonType,
    region: unlockModalRegion,
    text: 'watch video ad',
    ...(options ? { options } : {}),
  }),
  createAccountUnlockModal: (options?: SendEventParams['options']) => ({
    name: createAccountCitationUnlockModal,
    type: buttonType,
    region: unlockModalRegion,
    text: 'create account',
    ...(options ? { options } : {}),
  }),
  homePageMainCitationsCardCTA: () => ({
    name: createCitations,
    type: buttonType,
    region: homepageMainWritingCTARegion,
  }),
  homePageMainWritingCardCTA: () => ({
    name: checkYourPaper,
    type: buttonType,
    region: homepageMainWritingCTARegion,
    force: true,
  }),
  citationHomepageModalSignIn: (options?: SendEventParams['options']) => ({
    name: citationUnlockModal,
    type: buttonType,
    region: unlockModalRegion,
    text: 'sign in',
    ...(options ? { options } : {}),
  }),
  formPageAddAnnotationCTA: () => ({
    name: formPageAddAnnotationCTA,
    type: buttonType,
    region: formPageRegion,
  }),
  createManualCitationCTA: (region: Region) => ({
    name: createManualCitationCTA,
    type: buttonType,
    region,
  }),
  worldCatLogoClick: () => ({
    name: worldCatLogo,
    type: componentType,
    force: true,
  }),
  findAtMyLibraryClick: () => ({
    name: findAtMyLibrary,
    type: linkType,
    force: true,
  }),
  citationsFlowClickUpdate: (source, citationMetadata) => ({
    name: updateCitation,
    type: buttonType,
    value: source,
    citationMetadata,
  }),
  copyAllCitationsClick: () => ({
    name: copyAllCitations,
    type: buttonType,
    region: bibliographyModuleRegion,
  }),
  formPageAddContributorsCTA: () => ({
    name: addContributors,
    type: buttonType,
    region: formPageRegion,
  }),
  deleteCitationClick: () => ({
    name: deleteCitation,
    type: buttonType,
    region: citationMenuRegion,
  }),
  editCitationClick: () => ({
    name: editCitation,
    type: buttonType,
    region: citationMenuRegion,
  }),
  reviewCitationClick: () => ({
    name: reviewCitation,
    type: buttonType,
    region: bibliographyModuleRegion,
  }),
  ignoreValidationClick: () => ({
    name: ignoreValidation,
    type: buttonType,
    region: bibliographyModuleRegion,
  }),
  addNoteClick: () => ({
    name: addCitationNote,
    type: buttonType,
    region: citationMenuRegion,
  }),
  visitSourceLinkClick: () => ({
    name: visitSourceLink,
    type: buttonType,
    region: citationMenuRegion,
  }),
  createNewCitationClick: () => ({
    name: createCitation,
    type: buttonType,
    region: bibliographyModuleRegion,
  }),
  exportModuleExportCitationsClick: (value: string) => ({
    name: exportCitation,
    type: buttonType,
    region: exportAllModuleRegion,
    value,
  }),
  exportSelectedCitationsClick: () => ({
    name: exportSelectedCitations,
    type: buttonType,
    region: checkboxesMenuRegion,
  }),
  deleteSelectedCitationsClick: () => ({
    name: deleteSelectedCitations,
    type: buttonType,
    region: checkboxesMenuRegion,
  }),
  copySelectedCitationsClick: () => ({
    name: copySelectedCitations,
    type: buttonType,
    region: checkboxesMenuRegion,
  }),
  unlockModalSponsoredClick: (options?: SendEventParams['options']) => ({
    name: viewSponsoredMessage,
    type: buttonType,
    region: clickToContinueCitingRegion,
    ...(options ? { options } : {}),
  }),
  unlockModalSubscribeClick: (value: string, options?: SendEventParams['options']) => ({
    name: signUp,
    type: buttonType,
    region: unlockCitationRegion,
    value,
    ...(options ? { options } : {}),
  }),
  unlockModalSignInClick: (options?: SendEventParams['options']) => ({
    name: signIn,
    type: buttonType,
    region: unlockCitationRegion,
    ...(options ? { options } : {}),
  }),
  copyBibliographyCitationClick: () => ({
    name: copyCitation,
    type: buttonType,
    region: myCitationListRegion,
  }),
  copyBibliographyCitationFromMenu: () => ({
    name: copyCitation,
    type: buttonType,
    region: copyInTextCitationMenuRegion,
  }),
  exportAllCitationsClick: () => ({
    name: exportAllCitations,
    type: buttonType,
    region: bibliographyModuleRegion,
  }),
  checkPaperAfterCopy: () => ({
    name: checkPaper,
    type: buttonType,
    region: myCitationListRegion,
  }),
  checkPaperAfterLogout: () => ({
    name: checkYourPaper,
    type: buttonType,
    region: paperCheckerWidgetRegion,
  }),
  signUpClick: (value) => ({
    name: signUp,
    type: buttonType,
    value,
  }),
  lookForWebsiteAfterSearchResult: () => ({
    name: lookingForWebsite,
    type: buttonType,
    region: empCitationSearchResultRegion,
  }),
  searchWithJstorAfterSearchResult: () => ({
    name: searchWithJstor,
    type: buttonType,
    region: empCitationSearchResultRegion,
  }),
  searchWithCrossrefAfterSearchResult: () => ({
    name: searchWithCrossref,
    type: buttonType,
    region: empCitationSearchResultRegion,
  }),
  plagiarismUpsellCardCTA: (name: string) => ({
    name,
    type: buttonType,
    region: upgradeContainerRegion,
  }),
  gatedExportContinueCTA: (text: string) => ({
    name: doNotUpgrade,
    type: buttonType,
    region: exportCitationRegion,
    text,
  }),
  gatedExportUpgradeCTA: (text: string) => ({
    name: upgrade,
    type: buttonType,
    region: exportCitationRegion,
    text,
  }),
  citationLimitApproachingContinueCTA: (text: string) => ({
    name: doNotUpgrade,
    type: buttonType,
    region: createCitationRegion,
    text,
  }),
  citationLimitApproachingUpgradeCTA: (text: string) => ({
    name: upgrade,
    type: buttonType,
    region: createCitationRegion,
    text,
  }),
  citationLimitReachedUpgradeCTA: (text: string) => ({
    name: upgrade,
    type: buttonType,
    region: upgradeCreateCitationRegion,
    text,
  }),
  foldersPageExpirationUpgradeCTA: (text: string) => ({
    name: upgrade,
    type: buttonType,
    region: upgradeViewCitationListRegion,
    text,
  }),
  bibPageExpirationContinueCTA: (text: string) => ({
    name: doNotUpgrade,
    type: buttonType,
    region: viewCitationListRegion,
    text,
  }),
  bibPageExpirationUpgradeCTA: (text: string) => ({
    name: upgrade,
    type: buttonType,
    region: viewCitationListRegion,
    text,
  }),
  citationStyleClick: (text: string) => ({
    name: citationStyle,
    type: buttonType,
    interactionType: select,
    text,
  }),
  moreCitationsStyleClick: (interactionType: InteractionType) => ({
    name: moreCitationStyles,
    type: dropdownType,
    interactionType,
  }),
  topSideNavItemClick: (value: string, text: string) => ({
    eventname: selectNavShortcut,
    name: navShortcut,
    type: linkType,
    interactionType: select,
    region: sideNavRegion,
    value,
    text,
  }),
  topNavItemClick: (value: string, text: string) => ({
    eventname: selectNavShortcut,
    name: navShortcut,
    type: linkType,
    interactionType: select,
    region: topNavRegion,
    value,
    text,
  }),
  siteLogoClick: (name: string) => ({
    name,
    type: linkType,
  }),

  upgradeTopNavClick: () => ({
    eventname: clickUpgrade,
    name: upgrade,
    type: linkType,
    region: topNavRegion,
  }),

  upgradeSourcePageCTA: (eventname: string, name: string) => ({
    eventname,
    name,
    type: buttonType,
  }),

  upgradeSearchPageCTA: (eventname: string, name: string) => ({
    eventname,
    name,
    type: buttonType,
  }),

  priceModalClaimOfferClick: (text: string) => ({
    name: claimOffer,
    text,
    type: buttonType,
  }),
  freeCTAUpgradeClick: () => ({
    name: tryForFree,
    region: tryCitationStylesRegion,
    type: buttonType,
  }),
  changeCitationStyleModalContinueClick: () => ({
    name: modalContinue,
    type: buttonType,
    region: changeCitationStyleModalRegion,
  }),
  upgradeBannerCTA: () => ({
    name: upgradeBanner,
    type: buttonType,
    region: topUpgradeBannerRegion,
  }),
  newCitationListModalCreateClick: () => ({
    name: modalCreateNewList,
    type: buttonType,
    region: newCitationListModalRegion,
  }),
  newCitationListModalStartClick: () => ({
    name: modalStartFreeTrial,
    type: buttonType,
    region: newCitationListModalRegion,
  }),
  citationValidityCreateAccountClick: (citationMetadata) => ({
    name: createAccount,
    type: buttonType,
    interactionType: click,
    region: citationsExpiring,
    citationMetadata,
  }),
  saveAllCitationsCreateAccountClick: () => ({
    name: createAccount,
    type: buttonType,
    interactionType: click,
    region: saveAllCitations,
  }),
  createFreeAccountAdUnlockModalClick: () => ({
    name: createAFreeAccount,
    type: buttonType,
    region: clickToContinueCitingRegion,
  }),
  tryItForFreeTodayAdUnlockModalClick: () => ({
    name: tryItForFreeToday,
    type: buttonType,
    region: clickToContinueCitingRegion,
  }),
  writingAssistantBannerClick: () => ({
    name: getStarted,
    type: buttonType,
    interactionType: click,
    region: writingAssistantBanner,
  }),
  proofReaderReviewClick: (value: string) => ({
    eventname: clickReview,
    name: review,
    type: buttonType,
    interactionType: click,
    value,
  }),
  proofReaderRewriteClick: (text: string) => ({
    name: paraphrase,
    type: icon,
    interactionType: click,
    text,
  }),
  proofReaderExpandClick: (text: string) => ({
    name: expand,
    type: icon,
    interactionType: click,
    text,
  }),
  proofReaderShortenClick: (text: string) => ({
    name: shorten,
    type: icon,
    interactionType: click,
    text,
  }),
  proofReaderRewriteSuggestionClick: (
    text: string,
    value: string,
    citationMetadata: CitationMetadata
  ) => {
    const metadata = citationMetadata as any
    const elementNameMap = {
      accept: paraphraseSuggestion,
      regenerate: regenerateSuggestion,
      flag: flagParaphraseSuggestion,
    }
    return {
      name: elementNameMap[metadata?.proofReaderCardAction],
      type: buttonType,
      interactionType: metadata?.proofReaderCardAction === 'accept' ? accept : click,
      text,
      value,
    }
  },
  proofReaderExpandSuggestionClick: (
    text: string,
    value: string,
    citationMetadata: CitationMetadata
  ) => {
    const proofReaderCardAction = (citationMetadata as any)?.proofReaderCardAction

    const elementNameMap = {
      accept: expandSuggestion,
      regenerate: regenerateExpandSuggestion,
      flag: flagExpandSuggestion,
    }

    const isAcceptOrRegenerate =
      proofReaderCardAction === accept || proofReaderCardAction === regenerate

    return {
      name: elementNameMap[proofReaderCardAction],
      type: buttonType,
      interactionType: proofReaderCardAction === accept ? accept : click,
      text,
      value,
      citationMetadata: isAcceptOrRegenerate ? citationMetadata : undefined,
    }
  },
  proofReaderShortenSuggestionClick: (
    text: string,
    value: string,
    citationMetadata: CitationMetadata
  ) => {
    const proofReaderCardAction = (citationMetadata as any)?.proofReaderCardAction

    const elementNameMap = {
      accept: shortenSuggestion,
      regenerate: regenerateShortenSuggestion,
      flag: flagShortenSuggestion,
    }
    const isAcceptOrRegenerate =
      proofReaderCardAction === accept || proofReaderCardAction === regenerate
    return {
      name: elementNameMap[proofReaderCardAction],
      type: buttonType,
      interactionType: proofReaderCardAction === accept ? accept : click,
      text,
      value,
      citationMetadata: isAcceptOrRegenerate ? citationMetadata : undefined,
    }
  },
  proofReaderSynonymClick: (text: string) => ({
    name: synonym,
    type: icon,
    interactionType: click,
    text,
  }),
  proofReaderSynonymSuggestionClick: (text: string, value: string) => ({
    name: synonymSuggestion,
    type: textType,
    interactionType: accept,
    text,
    value,
  }),
  proofReaderFeedbackCardClick: (
    text: string,
    value: string,
    id: string,
    citationMetadata: CitationMetadata
  ) => {
    const metadata = citationMetadata as any
    const cardActionMap = {
      accept,
      reject,
      click,
    }
    return {
      name:
        cardActionMap[metadata?.proofReaderCardAction] === 'click'
          ? flagFeedbackCard
          : feedbackCard,
      type: buttonType,
      region: metadata?.proofReaderCardtype === 'GRAMMAR' ? grammar : clarity,
      interactionType: cardActionMap[metadata?.proofReaderCardAction],
      text,
      value,
      id,
    }
  },
  undoRedoClick: (
    name: Name | string,
    type: ElementType,
    interactionType: InteractionType,
    value?: string,
    text?: string,
    id?: string
  ) => {
    return {
      name,
      type,
      interactionType,
      value,
      text,
      id,
    }
  },
  carousalImageGetStartedClick: (name: string, region: Region) => ({
    name,
    type: buttonType,
    interactionType: click,
    region,
  }),
  bannerTextGetStartedClick: (name: string, region: Region) => ({
    name,
    type: buttonType,
    interactionType: click,
    region,
  }),
  proofReaderRetryErrorClick: (value: string) => ({
    name: 'retry',
    type: buttonType,
    interactionType: click,
    value,
  }),
  expandClarityReasonClick: (text: string, value: string, id: string) => ({
    name: 'learn why',
    type: 'drop down',
    interactionType: expand,
    region: clarity,
    text,
    value,
    id,
  }),
  contractClarityReasonClick: (text: string, value: string, id: string) => ({
    name: 'learn why',
    type: 'drop down',
    interactionType: collapse,
    region: clarity,
    text,
    value,
    id,
  }),
  expandPaperListClick: () => ({
    name: papersList,
    type: dropdownType,
    interactionType: expand,
    region: leftNav,
  }),
  collapsePaperListClick: () => ({
    name: papersList,
    type: dropdownType,
    interactionType: collapse,
    region: leftNav,
  }),
  startNewPaperClick: () => ({
    name: startNewPaper,
    type: linkType,
    interactionType: click,
    region: leftNav,
  }),
  citationsLeftNavClick: () => ({
    name: citationsTitle,
    type: linkType,
    interactionType: click,
    region: leftNav,
  }),
  plagiarismLeftNavClick: () => ({
    name: plagiarismTitle,
    type: linkType,
    interactionType: click,
    region: leftNav,
  }),
  randomListPaperClick: () => ({
    name: paper,
    type: linkType,
    interactionType: select,
    region: leftNav,
  }),
}

export const WTDashboardOnboarding = 'wt dashboard onboarding flow'

type TransactionType = typeof WTDashboardOnboarding

export interface ClickstreamInteractionTransaction {
  type: TransactionType
  metadata: {
    step: number
    total_steps: number
  }
}

export type Transactions = {
  dashboardTourTransactionStep: (step: number) => ClickstreamInteractionTransaction
}

export const transactions: Transactions = {
  dashboardTourTransactionStep: (step) => ({
    type: WTDashboardOnboarding,
    metadata: {
      step,
      total_steps: 3,
    },
  }),
}

export const origins = Object.keys(interactions).reduce(
  (origins, interactionName) => ({ ...origins, [interactionName]: interactionName }),
  {} as InteractionOrigins
)

type InteractionOrigins = {
  [Interaction in keyof Interactions]: Interaction
}

export type PlusTabCtaOrigins =
  | `${typeof HOMEPAGE_FEATURE_TOUR}-${typeof TYPE_CITATIONS}`
  | `${typeof HOMEPAGE_FEATURE_TOUR}-${typeof TYPE_PLAGIARISM}`
  | `${typeof HOMEPAGE_FEATURE_TOUR}-${typeof TYPE_GRAMMAR}`
  | `${typeof HOMEPAGE_FEATURE_TOUR}-${typeof TYPE_EXPERT_CHECK}`

export type CardCtaOrigins =
  | `${typeof HOMEPAGE_CARD}-${typeof TYPE_CHECK_PAPER}`
  | `${typeof HOMEPAGE_CARD}-${typeof TYPE_CREATE_CITATIONS}`

export type AccountGateModalOrigins =
  | `${AuthModalOrigin.CREATE_CITATION_HOMEPAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.CREATE_CITATION_HOMEPAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.CREATE_CITATION_HOMEPAGE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.CHECK_PAPER_HOMEPAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.CHECK_PAPER_HOMEPAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.CHECK_PAPER_HOMEPAGE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.SOURCE_BANNER_PAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.SOURCE_BANNER_PAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.SOURCE_BANNER_PAGE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.VIEW_PAGE_EXPORT}-${typeof CLOSE}`
  | `${AuthModalOrigin.VIEW_PAGE_EXPORT}-${typeof LOGIN}`
  | `${AuthModalOrigin.VIEW_PAGE_EXPORT}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.CITATION_FORM_PAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.CITATION_FORM_PAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.CITATION_FORM_PAGE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.OIM_VIEWPAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.OIM_VIEWPAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.OIM_VIEWPAGE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.CFC_VIEWPAGE_EXIT_GUEST}-${typeof CLOSE}`
  | `${AuthModalOrigin.CFC_VIEWPAGE_EXIT_GUEST}-${typeof LOGIN}`
  | `${AuthModalOrigin.CFC_VIEWPAGE_EXIT_GUEST}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.ACCOUNT_STYLE_GATE_VIEWPAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.ACCOUNT_STYLE_GATE_VIEWPAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.ACCOUNT_STYLE_GATE_VIEWPAGE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.REDESIGNED_UNLOCK_MODAL}-${typeof CLOSE}`
  | `${AuthModalOrigin.REDESIGNED_UNLOCK_MODAL}-${typeof LOGIN}`
  | `${AuthModalOrigin.REDESIGNED_UNLOCK_MODAL}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.UPGRADE_MODAL}-${typeof CLOSE}`
  | `${AuthModalOrigin.UPGRADE_MODAL}-${typeof LOGIN}`
  | `${AuthModalOrigin.UPGRADE_MODAL}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.NEW_CITATION_LIST_MODAL}-${typeof CLOSE}`
  | `${AuthModalOrigin.NEW_CITATION_LIST_MODAL}-${typeof LOGIN}`
  | `${AuthModalOrigin.NEW_CITATION_LIST_MODAL}-${typeof CREATE_ACCOUNT}`

export type AuthModalOrigins =
  | `${AuthModalOrigin.NAV_HEADER}-${typeof CLOSE}`
  | `${AuthModalOrigin.NAV_HEADER}-${typeof LOGIN}`
  | `${AuthModalOrigin.NAV_HEADER}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.PRICE_TABLE}-${typeof CLOSE}`
  | `${AuthModalOrigin.PRICE_TABLE}-${typeof LOGIN}`
  | `${AuthModalOrigin.PRICE_TABLE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.DASHBOARD_PAGE_WIDGET}-${typeof CLOSE}`
  | `${AuthModalOrigin.DASHBOARD_PAGE_WIDGET}-${typeof LOGIN}`
  | `${AuthModalOrigin.DASHBOARD_PAGE_WIDGET}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.MYACCOUNT_PAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.MYACCOUNT_PAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.MYACCOUNT_PAGE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.SOURCE_SELECTION_PAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.SOURCE_SELECTION_PAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.SOURCE_SELECTION_PAGE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.UCF_UNBLOCK_MODAL}-${typeof CLOSE}`
  | `${AuthModalOrigin.UCF_UNBLOCK_MODAL}-${typeof LOGIN}`
  | `${AuthModalOrigin.UCF_UNBLOCK_MODAL}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.BIBLIOGRAPHY_PAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.BIBLIOGRAPHY_PAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.BIBLIOGRAPHY_PAGE}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.HOMEPAGE_UPGRADE_BANNER}-${typeof CLOSE}`
  | `${AuthModalOrigin.HOMEPAGE_UPGRADE_BANNER}-${typeof LOGIN}`
  | `${AuthModalOrigin.HOMEPAGE_UPGRADE_BANNER}-${typeof CREATE_ACCOUNT}`
  | `${AuthModalOrigin.WRITING_ASSISTANT_PAGE}-${typeof CLOSE}`
  | `${AuthModalOrigin.WRITING_ASSISTANT_PAGE}-${typeof LOGIN}`
  | `${AuthModalOrigin.WRITING_ASSISTANT_PAGE}-${typeof CREATE_ACCOUNT}`

type Origins =
  | keyof InteractionOrigins
  | PlusTabCtaOrigins
  | AccountGateModalOrigins
  | CardCtaOrigins
  | AuthModalOrigins

export type UserClickPayload = {
  eventname?: EventName | string
  origin: Origins
  value?: string
  id?: string
  step?: number
  region?: Region
  text?: string
  name?: Name | string
  options?: SendEventParams['options']
  style?: string
  interactionType?: InteractionType
  citationMetadata?: CitationMetadata
  type?: ElementType
}
